import { render } from "./ContentDetail.vue?vue&type=template&id=ec6d0ba8"
import script from "./ContentDetail.vue?vue&type=script&lang=js"
export * from "./ContentDetail.vue?vue&type=script&lang=js"

import "./ContentDetail.vue?vue&type=style&index=0&id=ec6d0ba8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__